import React from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ReactMarkdown from 'react-markdown';
import breaks from 'remark-breaks';
import { Grid, TextEnterExit } from 'style';

const MarkdownImage = props => {
    let altTag = '';
    if (props.alt != '') {
        altTag = <ImageCaption>{props.alt}</ImageCaption>;
    }
    return (
        <ImageWrapper fit={props.src.indexOf('#fit') > -1}>
            <img {...props} />
            {altTag}
        </ImageWrapper>
    );
};

export const ArticleTextComponent = ({ text }) => (
    <ReactMarkdown
        source={text}
        containerTagName="div"
        css={markdown}
        renderers={{ root: 'div', image: MarkdownImage }}
        plugins={[breaks]}
    />
);

class ArticleComponent extends React.Component {
    render() {
        return (
            <Grid.InnerContainer id="ArticleComponent" className='ArticleFormat'>
                <Grid.Row>
                    <Grid.Col>
                        {this.props.children}
                        {/*  */}
                    </Grid.Col>
                </Grid.Row>
            </Grid.InnerContainer>
        );
    }
}

const Text = styled.div`
    max-width: 700px;
    margin: 0 auto;
    ${TextEnterExit};
`;
const markdown = css``;

export const Title = styled.div`
    width: 100%;
    max-width: 700px;
    margin: 0 auto;
`;
const ImageWrapper = styled.div`
    margin: ${props => (props.fit ? '40px 0' : '40px -100px')};
    img {
        max-width: 100%;
    }
    img[src*='#fig'] {
        max-width: 110%;
    }
`;
const ImageCaption = styled.div`
    width: 100%;
    font-size: 14px;
    color: gray;
    text-align: center;
    margin-bottom: 80px;
    display: block;
`;

export default ArticleComponent;
